export const PC = 'PC';
export const MOBILE = 'MOBILE';
export const PAD = 'PAD';

export const platformObj = {
  [PC]: '电脑',
  [MOBILE]: '手机',
  [PAD]: '平板',
  电脑: PC,
  手机: MOBILE,
  平板: PAD,
};

export interface Platform {
  label: string;
  value: string;
}

export const platformList: Platform[] = [
  {
    label: platformObj[MOBILE],
    value: MOBILE,
  },
  {
    label: platformObj[PAD],
    value: PAD,
  },
  {
    label: platformObj[PC],
    value: PC,
  },
];

export const platformSize = {
  [MOBILE]: {
    width: 384,
    height: 660,
  },
  [PAD]: {
    width: 768,
    height: 1024,
  },
  [PC]: {
    width: 1366,
    height: 768,
  },
};
